import * as React from "react";
import { BaseDict } from "../../../dict";
import { CardPropsHandlers } from "../../../../../typings";
import { renderLiveStreamingIcon } from "./renderLiveStreamingIcon";
import { renderStatisticsIcon } from "./renderStatisticsIcon";
import { renderFastMarketIcon } from "./renderFastMarketIcon";
import { renderPulseBetIcon } from "./renderPulseBetIcon";
import { Event } from "../../../../../contracts";
import { getDictPhrase } from "../../../../../helpers";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";

export const renderEventIcons = (event: Event, dict: BaseDict, isDesktop: boolean, handlers: CardPropsHandlers) =>
    <>
        {renderFirstAvailableIcon(event, dict, isDesktop, handlers)}
        {renderLiveStreamingIcon(event.livestreamIcon.active, getDictPhrase(dict,event.livestreamIcon.tooltip), true, handlers.liveStream)}
    </>

const renderFirstAvailableIcon = (event: Event, dict: BaseDict, isDesktop: boolean, handlers: CardPropsHandlers) => {
    if (isDesktop && event.statisticsIcon.active) {
        return renderStatisticsIcon(event.statisticsIcon.active, getDictPhrase(dict, event.statisticsIcon.tooltip), handlers.statistics);
    }

    if (!isDesktop && event.pulsebetIcon.active) {
        return renderPulseBetIcon(event.pulsebetIcon.active, getDictPhrase(dict,event.pulsebetIcon.tooltip));
    }

    if (event.isLive) {
        return renderFastMarketIcon(event.fastmarketIcon.active, getDictPhrase(dict,event.fastmarketIcon.tooltip));
    }

    return createEmptyTooltipIcon();
}